import angular from 'angular';
import angularRoute from 'angular-route';

import ResetPasswordCtrl from './reset/reset-password-ctrl';
import ResetPasswordFromKeyCtrl from './reset-from-key/reset-from-key-ctrl';
import routes from './password-routes';

export default angular.module('password', [angularRoute])
    .controller('ResetPasswordCtrl', ResetPasswordCtrl)
    .controller('ResetPasswordFromKeyCtrl', ResetPasswordFromKeyCtrl)
    .config(routes)
    .name;




// WEBPACK FOOTER //
// ./password/password-module.js